module.exports = __webpack_public_path__ + "static/media/trash-icon.b4b1608c.png";